const TemplateTypes = {
    GET_TEMPLATES: "GET_TEMPLATES",
    GET_TEMPLATES_SUCCESS: "GET_TEMPLATES_SUCCESS"
};

export { TemplateTypes };